import React, {ReactNode} from "react";
import {OrbitComponent} from "../../../base-components/orbit-component/orbit-component";
import {IconTitleTextTooltipContainerBox} from "./boxes/container.box";
import {IconTitleTextTooltipTextContainerBox} from "./boxes/text-container.box";
import {IconTitleTextTooltipTitleBox} from "./boxes/title.box";
import {IconTitleTextTooltipIconBox} from "./boxes/icon.box";
import { Check } from "@sparkware/app-utils";
import { SeparatorBox } from "./boxes/separator/separator.box";

interface IconHeaderTextTooltipProps {
    icon: string | ReactNode;
    title?: string;
    text: string | ReactNode;
    onClick?: () => any;
}

export class IconTitleTextTooltip extends OrbitComponent<IconHeaderTextTooltipProps> {
    render() {
        const icon = Check.isString(this.props.icon) ? 
            <IconTitleTextTooltipIconBox src={this.props.icon.toString()} alt="Rewards" /> :
            this.props.icon;

        return (
            <IconTitleTextTooltipContainerBox showCursor={Boolean(this.props.onClick)}
                                              onClick={this.props.onClick}>
                {icon}
                <SeparatorBox/>
                <IconTitleTextTooltipTextContainerBox className="icon-title-text-tooltip-text-container">
                    {this.props.title && <IconTitleTextTooltipTitleBox className="title">{this.props.title}</IconTitleTextTooltipTitleBox>}
                    {this.props.text}
                </IconTitleTextTooltipTextContainerBox>
            </IconTitleTextTooltipContainerBox>
        );
    }
}
